module.exports = __webpack_public_path__ + "img/LogoAruba_Gris.3547f99f.png";